import { render, staticRenderFns } from "./ResultFieldEditor.vue?vue&type=template&id=19cb1795&scoped=true&"
import script from "./ResultFieldEditor.vue?vue&type=script&lang=js&"
export * from "./ResultFieldEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cb1795",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
